import React from "react";
import { useTranslation } from "react-i18next";

export default function PageChange(props) {
  var { t } = useTranslation()

  return (
    <>
      <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
        <div className="w-12 h-12 mb-4 ease-linear border-4 border-t-4 border-gray-200 rounded-full loader"></div>
        <h2 className="text-xl font-semibold text-center text-white">
          {" "}
          {props.data} {t("wait")}
        </h2>
      </div>
    </>
  );
}
